import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbRoleMappingConstParam extends IAloDbBaseConstParam {
    MAP_OBJECT:string|null  
    MAP_ID:number|null
    USR_ID:number|null
    ROL_ID:number|null
    ROL_KEY:string|null
    ROL_IS_EXPLICIT:boolean
  }

export class AloDbRoleMapping extends AloDbBase {
        
    public MAP_OBJECT:string|null  
    public MAP_ID:number|null
    public USR_ID:number|null
    public ROL_ID:number|null
    public ROL_KEY:string|null
    public ROL_IS_EXPLICIT:boolean
    
    constructor({MAP_OBJECT,MAP_ID,USR_ID,ROL_ID,ROL_KEY,ROL_IS_EXPLICIT,...args }:IAloDbRoleMappingConstParam = {} as IAloDbRoleMappingConstParam) {
        super(args)
        this.MAP_OBJECT = MAP_OBJECT
        this.MAP_ID = MAP_ID
        this.USR_ID = USR_ID        
        this.ROL_ID = ROL_ID   
        this.ROL_KEY = ROL_KEY   
        this.ROL_IS_EXPLICIT = ROL_IS_EXPLICIT
    }

    static createAloDbRoleMappingArray(datas:any) {
        return new AloBaseArray(AloDbRoleMapping,datas)
    }

    static createAloDbRoleMapping(data:any) {
        return new AloDbRoleMapping(data)
    }
}
